
<div>
    <f-title :title="$t('contract.termsOfCancelation') "  />
    <v-row class="no-frame"  >
        <v-col class="no-frame col-4 pr-2" v-show="monthsNeeded">
            <f-read-only-field
                class  = "w-100 mt-1"
                :dense = "true"
                :label = "$t('contract.toc.months')"
                :value = "contract.tocMonths"
                color  = "pt-0-5 pl-1 ro-background"
            />
        </v-col>
        <v-col class="no-frame" :class="monthsNeeded ? 'pl-2' : ''">
            <f-read-only-field
                class  = "w-100 mt-1"
                :dense = "true"
                :label = "$t('contract.toc.until')"
                :value = "contract.tocType ? contract.tocType.name : null"
                color  = "pt-0-5 pl-1 ro-background"
            />
        </v-col>
    </v-row>
    <v-row class="no-frame"  >
        <v-textarea
            class          = "pt-0 ro-background"
            v-model        = "contract.tocComment"
            rows           = "3"
            :readonly      = "true"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
            no-resize
            hide-details
        />
    </v-row>
    <v-row class="no-frame"  >
        <v-col class="no-frame col-6">
            <v-checkbox
                v-model   = "contract.tocRewal"
                :label    = "$t('contract.toc.renewal.automatic')"
                :ripple   = "false"
                :readonly = "true"
                style     = "margin-top:16px"
                hide-details
            />
        </v-col>
        <v-col class="no-frame col-2 pr-2">
            <f-read-only-field
                v-show="contract.tocRewal"
                class  = "w-100 mt-1"
                :dense = "true"
                :label = "$t('contract.toc.renewal.duration')"
                :value = "contract.tocRenewalDuration"
                color  = "pt-0-5 pl-1 ro-background"
            />
        </v-col>
        <v-col class="no-frame pl-2">
            <f-read-only-field
                v-show="contract.tocRewal"
                class  = "w-100 mt-1"
                :dense = "true"
                :label = "$t('contract.toc.renewal.period')"
                :value = "contract.renewalType ? contract.renewalType.name : null"
                color  = "pt-0-5 pl-1 ro-background"
            />
        </v-col>
    </v-row>

</div>
